module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-6@3x.jpg?e9a2a22c";